import { _pushMetrics } from "./_metrics";

export const pushMetrics =
    typeof window !== "undefined"
        ? _pushMetrics
        : ((() => {
              // no-op
          }) as typeof _pushMetrics);
